import Vue from "vue";
import Vuetify from "vuetify/lib";
import { defaultLanguage } from "./i18n";

Vue.use(Vuetify);
import hr from "vuetify/src/locale/hr";
import en from "vuetify/src/locale/en";

const vuetify = new Vuetify({
  icons: {
    iconfont: "fa",
  },
  lang: {
    current: defaultLanguage.split("-")[0],
    locales: { hr, en },
  },
  theme: {
    // keep in mind that changing theese,
    // you should might need to change them in @/assets/scss/variables.scss as well
    // reason for duplicates is there
    themes: {
      light: {
        primary: {
          base: "#2790E5",
          lighten1: "#A0D2FA",
          lighten2: "#D9EDFD",
        },
        secondary: {
          base: "#004BB0",
          darken1: "#17437F",
        },
        accent: "#C638ED",
        error: {
          base: "#E0365D",
          lighten1: "#EF9AAE",
          darken1: "#B32848",
        },
        warning: {
          base: "#F5B942",
          lighten1: "#FADBA0",
        },
        success: {
          base: "#4EC48A",
          lighten1: "#A6E1C4",
        },
        black: {
          base: "#22262C",
          lighten1: "#393B3E",
          lighten2: "#838486",
          lighten3: "#E6E6E7",
        },
      },
      dark: {
        primary: {
          base: "#42A5F5",
          lighten1: "#A0D2FA",
          lighten2: "#D9EDFD",
        },
        secondary: {
          base: "#004BB0",
          darken1: "#17437F",
          darken2: "#071E3D",
        },
        accent: "#9E18C0",
        error: {
          base: "#E0365D",
          lighten1: "#EF9AAE",
          darken1: "#B32848",
        },
        warning: {
          base: "#F5B942",
          lighten1: "#FADBA0",
        },
        success: {
          base: "#4EC48A",
          lighten1: "#A6E1C4",
        },
        black: {
          base: "#22262C",
          lighten1: "#393B3E",
          lighten2: "#838486",
          lighten3: "#E6E6E7",
        },
      },
    },
  },
});

export default vuetify;
